import React from 'react';
import { Card, CardContent } from '@/components/ui';

export function SystemInfo() {
  const info = [
    { label: 'Phiên bản hệ thống', value: 'GreenSpace v2.5.0' },
    { label: 'Môi trường', value: 'Production' },
    { label: 'Máy chủ', value: 'server-01.greenspace.vn' },
    { label: 'Hệ điều hành', value: 'Ubuntu 22.04 LTS' },
    { label: 'Thời gian hoạt động', value: '15 ngày 03:45:12' },
    { label: 'Cập nhật lần cuối', value: '10/05/2024 14:30' },
  ];

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Thông tin hệ thống</h3>
        
        <div className="flex-1 space-y-4">
          {info.map((item) => (
            <div key={item.label} className="flex justify-between items-center text-xs">
              <span className="font-bold text-slate-500">{item.label}</span>
              <span className="font-bold text-slate-700">{item.value}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50 flex items-center justify-center gap-4">
          <div className="flex items-center gap-1.5">
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
            <span className="text-[10px] font-bold text-slate-400">Node v18.16.0</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
            <span className="text-[10px] font-bold text-slate-400">PostgreSQL 15</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
